// Maps a route path (or path prefix) to the permission module it requires.
// Paths not listed here are always shown (e.g. Dashboard, Role & Permission,
// Old Vehicles) so we don't lock users out of unrelated screens by accident.
const PATH_MODULE_MAP = [
  // Exact paths
  ["/members", "member"],
  ["/fuel-access", "fuel_access"],
  ["/vehicle-registration", "blank_fuel_access"],
  ["/scan-history", "scan_history"],

  // Reports — exact paths
  ["/reports/vehicle-registration", "report_master_vehicle_registration"],
  ["/reports/scan", "report_master_scan"],
  ["/reports/vehicles-by-user", "report_vehicles_by_user"],
  ["/reports/vehicles-by-bunk", "report_vehicles_by_bunk"],
  ["/reports/vehicles-by-company", "report_vehicles_by_company"],
  ["/reports/vehicles-by-city", "report_vehicles_by_city"],
  ["/reports/vehicles-by-district", "report_vehicles_by_district"],
  ["/reports/vehicles-by-state", "report_vehicles_by_state"],
  ["/reports/vehicles-by-country", "report_vehicles_by_country"],
  ["/reports/scan-by-bunk", "report_scan_by_bunk"],
  ["/reports/scan-by-user", "report_scan_by_user"],
  ["/reports/scan-by-company", "report_scan_by_company"],
  ["/reports/scan-by-city", "report_scan_by_city"],
  ["/reports/scan-by-district", "report_scan_by_district"],
  ["/reports/scan-by-state", "report_scan_by_state"],
  ["/reports/scan-by-country", "report_scan_by_country"],

  // Prefix paths
  ["/master-data", "master_data"],
];

export function moduleForPath(pathname) {
  if (!pathname) return null;
  for (const [p, mod] of PATH_MODULE_MAP) {
    if (pathname === p || pathname.startsWith(`${p}/`)) return mod;
  }
  return null;
}

export function canAct(permissions, mod, action) {
  if (!mod) return true; // unmapped routes are open
  if (!permissions || typeof permissions !== "object") return false;
  const row = permissions[mod];
  if (!row || typeof row !== "object") return false;
  return !!row[action];
}

// Convenience for sidebar / button gating.
export function canViewPath(permissions, pathname) {
  const mod = moduleForPath(pathname);
  if (!mod) return true; // unmapped → always visible
  return canAct(permissions, mod, "view");
}
